import { baseUrl, postRequestOptions } from "../../common/cookie";
import React, { useState, useEffect } from "react";
import Loader from "../../common/loader";
import axios from "axios";
import { useLocation } from "react-router-dom";
function Login() {
  let [requestStatus, setRequestStatus] = useState(false);
  let [authStatus, setAuthStatus] = useState("");
  let query = new URLSearchParams(useLocation().search);

  let [email, setEmail] = useState(localStorage.getItem("email") || query.get("email") || "");
  let [password, setPassword] = useState("");

  // Check if user is already authenticated
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const authCheck = await axios.get(baseUrl + "auth", postRequestOptions);
        if (authCheck.status === 200) {
          // User is already authenticated, redirect to dashboard
          const accessRole = localStorage.getItem("accessRole");
          if (accessRole === "admin") {
            window.location.href = "/";
          } else if (accessRole === "member (risk report)") {
            window.location.href = "/view-risk-report";
          } else if (accessRole === "member (factsheet report)") {
            window.location.href = "/view-fact-sheet";
          } else {
            window.location.href = "/";
          }
        }
      } catch (error) {
        // User is not authenticated, stay on login page
        console.log("User not authenticated, showing login page");
      }
    };
    checkAuth();
  }, []);
  
  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setRequestStatus(true);
    // Read values directly from form inputs to support browser automation
    let form = event.currentTarget;
    let emailInput = form.querySelector('input[name="email"]') as HTMLInputElement;
    let passwordInput = form.querySelector('input[name="password"]') as HTMLInputElement;
    let emailValue = emailInput?.value || email;
    let passwordValue = passwordInput?.value || password;
    let formData = { email: emailValue, password: passwordValue };
    try {
      let auth = await axios.post(baseUrl + "login", formData, postRequestOptions);

      if (auth.data?.status === 200)  {
        let accessRole = auth.data.accessRole;
        let shareClass = auth.data.shareClass;

        localStorage.setItem("accessRole", accessRole);
        localStorage.setItem("shareClass", shareClass);

        if (accessRole === "admin") {
          window.location.href = "/";
        } else if (accessRole === "member (risk report)") {
          window.location.href = "/view-risk-report";
        } else if (accessRole === "member (factsheet report)") {
          window.location.href = "/view-fact-sheet";
        }
      } else {
        setAuthStatus(auth.data?.message || "Authentication failed.");
        setRequestStatus(false);
      }
    } catch (error) {
      setAuthStatus("Login failed due to server error. Please try again.");
      setRequestStatus(false);
      console.error("Login Error:", error);
    }
  }

  function OnChangeUsername(event: any) {
    setEmail(event.target.value);
  }
  function onChangePassword(event: any) {
    setPassword(event.target.value);
  }
  function handleResetPassword(event: any) {
    window.location.href = "/reset-password";
  }
  function handleSignUp(event: any) {
    window.location.href = "/sign-up";
  }

  if (requestStatus) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return (
    <div>
      <div className="container mt-5">
        <h1>Triada Capital Admin Login</h1>
      </div>

      <div className="row">
      <form className="login-card container mt-5" id="loginForm" onSubmit={handleSubmit}>  
          <div>
            <h4>
              <b>Email</b>
            </h4>
            <input type="email" className="formTextInput" title="email" name="email" value={email} onChange={(event) => OnChangeUsername(event)} />
          </div>
          <div>
            <h4>
              <b>Password</b>
            </h4>
            <input type="password" className="formTextInput" title="password" name="password" value={password} onChange={(event) => onChangePassword(event)} />
          </div>
          <p className="btn btn-auth" onClick={(event) => handleResetPassword(event)}>
            Forgot password? Reset Password
          </p>

          {authStatus ? <h4 className="error">{authStatus}</h4> : ""}
          <div className="auth-btn-container">
          <button type="submit" className="btn upload-btn auth-btn-1">              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
export default Login;
